import { Linkedin, Facebook, Youtube, Instagram, Twitter } from "lucide-react";

const socialLinks = [
  {
    name: "LinkedIn",
    url: "https://www.linkedin.com/company/entrepreneursacrossborders/",
    icon: Linkedin,
  },
  {
    name: "Facebook",
    url: "https://www.facebook.com/EntrepreneursAcrossBorders",
    icon: Facebook,
  },
  {
    name: "YouTube",
    url: "https://www.youtube.com/@EABorders",
    icon: Youtube,
  },
  {
    name: "Instagram",
    url: "https://www.instagram.com/eaborders/",
    icon: Instagram,
  },
  {
    name: "X",
    url: "https://x.com/EABordersOrg",
    icon: Twitter,
  },
];

const Footer = () => {
  return (
    <footer className="py-8 border-t bg-card">
      <div className="container mx-auto px-4 text-center">
        <div className="flex justify-center items-center gap-6 mb-4">
          {socialLinks.map((social) => (
            <a
              key={social.name}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Follow us on ${social.name}`}
              className="text-muted-foreground hover:text-primary transition-colors hover:scale-110 transform duration-200"
            >
              <social.icon className="h-6 w-6" />
            </a>
          ))}
        </div>
        <div className="mb-3">
          <a
            href="https://www.eaborders.org"
            target="_blank"
            rel="noopener noreferrer"
            className="text-muted-foreground hover:text-primary transition-colors hover:underline text-sm"
          >
            Visit EABorders.org
          </a>
        </div>
        <p className="text-muted-foreground">
          © {new Date().getFullYear()} EAB Connect. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
